"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderAccentText = exports.renderBoldText = void 0;
const react_1 = __importDefault(require("react"));
const renderBoldText = (chunks) => react_1.default.createElement("b", null, chunks);
exports.renderBoldText = renderBoldText;
const renderAccentText = (chunks) => react_1.default.createElement("b", null, react_1.default.createElement("i", null, chunks));
exports.renderAccentText = renderAccentText;
